<!---分享面板-->
<template>
  <layer
    mask-direction="Bottom"
    v-stat:show="{
      action: 'ZNZT_APP_activity_show_14',
      extend: { page: pageSource },
    }"
    :visible="visible"
    :layerName="layerName"
  >
    <div class="dlrLayer-bottom dlrShareLayer">
      <div class="dlrShare">
        <a
          v-for="item in shareChannels"
          :key="item.channelName"
          class="dlrShare-item"
          href="javaScript:;"
          v-stat:click="{
            action: item.clickActionName,
            extend: { page: pageSource },
          }"
          @click="share(item.channelName)"
        >
          <em class="icon-pic">
            <img :src="item.iconUrl" />
            <i class="lab" v-if="hasRedPacket && item.channelName === 'image'">
              抽红包
            </i>
          </em>
          <span>{{ item.text }}</span>
        </a>
      </div>
      <div class="dlrline-grey-line-4"></div>
      <a class="dlrLayerBottom-cancel" href="javaScript:;" @click="close"
        >取消</a
      >
    </div>
    <div class="dlrLayer-mask" @click="close"></div>
  </layer>
</template>
<script>
import Layer from '../Layer.vue';
export default {
  props: {
    layerName: {
      type: String,
      default: ''
    },
    shareChannelNames: {
      type: Array,
      default: function () {
        return [];
      }
    },
    pageSource: {
      type: String,
      default: ''
    },
    hasRedPacket: {
      type: Boolean,
      default: false
    }
  },
  name: 'SharePanel',
  components: {
    Layer
  },
  computed: {
    shareChannels () {
      const shareChannels = [{
        channelName: 'weixin',
        text: '微信',
        iconUrl: 'https://s.autoimg.cn/dealer/m/dealerUI/dlrShare/icon-weixin.png',
        clickActionName: 'ZNZT_APP_activity_15'
      },
      {
        channelName: 'weixincircle',
        text: '朋友圈',
        iconUrl: 'https://s.autoimg.cn/dealer/m/dealerUI/dlrShare/icon-pyq.png',
        clickActionName: 'ZNZT_APP_activity_16'
      },
      {
        channelName: 'image',
        text: '图片分享',
        iconUrl: 'https://s.autoimg.cn/dealer/m/dealerUI/dlrShare/icon-tupian.png',
        clickActionName: 'ZNZT_APP_activity_17'
      },
      {
        channelName: 'weibo',
        text: '新浪微博',
        iconUrl: 'https://s.autoimg.cn/dealer/m/dealerUI/dlrShare/icon-xinlang.png',
        clickActionName: 'ZNZT_APP_activity_18'
      }];
      return shareChannels.filter(o => this.shareChannelNames.includes(o.channelName));
    }
  },
  data () {
    return {
      visible: true
    };
  },
  methods: {
    close () {
      this.visible = false;
    },
    share (channelName) {
      this.close();
      this.$emit('share', channelName);
    }
  }
};
</script>
<style lang="scss">
.dlrShareLayer {
  background: #ffffff;
  border-radius: ptrd(32) ptrd(32) 0 0;
}

.dlrShare {
  height: ptrd(228);
  padding: ptrd(40) ptrd(20);
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  font-size: 0;
  display: flex;
  flex-wrap: nowrap;

  &::-webkit-scrollbar {
    width: 0 !important;
    display: none;
  }

  &-item {
    display: inline-block;
    min-width: ptrd(160);
    text-align: center;
    text-decoration: none;
    flex: 1;
    .icon-pic {
      position: relative;
      display: block;
      margin: 0 auto;
      width: ptrd(100);
      height: ptrd(100);

      img {
        width: 100%;
        pointer-events: none;
      }
    }

    span {
      display: block;
      font-size: ptrd(24);
      padding-top: ptrd(16);
      color: #111e36;
      line-height: ptrd(24);
    }

    .lab {
      position: absolute;
      left: ptrd(64);
      bottom: ptrd(88);
      font-size: ptrd(18);
      color: #ffffff;
      line-height: ptrd(18);
      padding: ptrd(5) ptrd(6);
      background: #fe4a3b;
      border-radius: ptrd(8) 0 ptrd(8) 0;
      z-index: 2;
    }
  }
}

.dlrline-grey-line-4 {
  height: ptrd(8);
  background: #f8f9fc;
}

.dlrLayerBottom-cancel {
  display: block;
  font-size: ptrd(32);
  color: #111e36;
  text-align: center;
  line-height: ptrd(100);
  flex-shrink: 0;
}

/*对小红包做适配*/
@media screen and (min-width: 320px) and (max-width: 374px) {
  .dlrShare-item .lab {
    font-size: ptrd(18 * 18/16);
    line-height: ptrd(18 * 18/16);
    padding: ptrd(5 * 18/16) ptrd(6 * 18/16);
    border-radius: ptrd(8 * 18/16) 0 ptrd(8 * 18/16) 0;
  }
}

@media screen and (min-width: 375px) and (max-width: 479px) {
}

@media screen and (min-width: 480px) and (max-width: 539px) {
  .dlrShare-item .lab {
    font-size: ptrd(18 * 18/20);
    line-height: ptrd(18 * 18/20);
    padding: ptrd(5 * 18/20) ptrd(6 * 18/20);
    border-radius: ptrd(8 * 18/20) 0 ptrd(8 * 18/20) 0;
  }
}

@media screen and (min-width: 540px) and (max-width: 639px) {
  .dlrShare-item .lab {
    font-size: ptrd(18 * 18/24);
    line-height: ptrd(18 * 18/24);
    padding: ptrd(5 * 18/24) ptrd(6 * 18/24);
    border-radius: ptrd(8 * 18/24) 0 ptrd(8 * 18/24) 0;
  }
}

@media screen and (min-width: 640px) {
  .dlrShare-item .lab {
    font-size: ptrd(18 * 18/28);
    line-height: ptrd(18 * 18/28);
    padding: ptrd(5 * 18/28) ptrd(6 * 18/28);
    border-radius: ptrd(8 * 18/28) 0 ptrd(8 * 18/28) 0;
  }
}
</style>